import { useEffect } from 'react'

import Cookies from 'js-cookie'

import { GCLID_COOKIE_KEY, getDomainName } from './utils'

function getGclidFromQuery() {
  const params = new URLSearchParams(window.location.search)
  return params.get('gclid')
}

export default function useGclidCookie() {
  useEffect(() => {
    if (typeof window === 'undefined') return

    const queryGclidValue = getGclidFromQuery()
    if (!queryGclidValue) return

    const currentValue = Cookies.get(GCLID_COOKIE_KEY)
    if (currentValue !== queryGclidValue) {
      const domain = getDomainName()
      const path = '/'
      const expires = 365
      Cookies.set(GCLID_COOKIE_KEY, queryGclidValue, { domain, path, expires })
    }
  }, [])
}
